module.exports = __webpack_public_path__ + "static/media/sf-test-9.605a5e0f.mp3";